import {SbBlokData, StoryblokComponent, storyblokEditable, useStoryblokApi} from "@storyblok/react";
import {IFeatureItem} from "../../types/IFeatureItem";
import ButtonGroup from "../partials/ButtonGroup";
import {useEffect, useState} from "react";
import classNames from "classnames";
import {ArrowRightIcon} from "@heroicons/react/20/solid";
import React from "react";


interface IProps {
    blok: {
        title: string,
        subtitle: string,
        container_padding: string,
        items: Array<IFeatureItem>,
        buttons: Array<any>
    } & SbBlokData
}

export default function RevealFeatures(props: IProps) {
    const blok = props.blok;
    const buttons = <ButtonGroup buttons={props.blok.buttons ?? []}/>

    const blokId = blok._uid;

    const [currentIndex, setCurrentIndex] = useState(0);
    const [nestedBlocks, setNestedBlocks] = useState(<div></div>);

    useEffect(() => {

        setNestedBlocks(<>
            {blok.items[currentIndex]?.sub_blocks?.map((nestedBlok: any, x: number) => (
                <StoryblokComponent blok={nestedBlok} key={x}/>
            ))}
        </>);

        if (currentIndex !== 0) {
            let item = document.getElementById(blokId + 'container');

            if (window.innerWidth < 480) {
                item = document.getElementById('nested'+blokId);
                // scroll to item smoothly
                item?.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'});
            }


        }
    }, [currentIndex])

    return (
        <div className={blok.container_padding || 'py-12'}  {...storyblokEditable(props.blok)}>
            <div className={'py-12'}>

                <div

                    className="mb-12 px-6 lg:px-8">
                    <div className="mx-auto max-w-4xl text-center"
                         data-aos={'fade-in'}
                    >
                        <h3 className={(props.blok.size || 'text-4xl sm:text-4xl') + " font-bold tracking-tight text-gray-900"}>
                            {blok.title}
                        </h3>
                        <p className="mt-6 text-lg leading-8 text-gray-600">
                            {blok.subtitle}
                        </p>

                        {buttons}
                    </div>
                </div>

                <div className={'px-6 max-w-5xl mx-auto'} id={blokId + 'container'}>
                    <div className={'flex flex-wrap gap-4 justify-center'}>
                        {blok.items.map((action, actionIdx) => (
                            <React.Fragment key={action.title + actionIdx}>
                                <div onClick={() => setCurrentIndex(actionIdx)}
                                     className={'flex gap-4 items-center bg-white p-2 rounded-lg cursor-pointer hover:bg-gray-100'}
                                     id={blokId + 'revealHeading' + actionIdx}>
                                    <span
                                        className={classNames(
                                            action.background_color || 'bg-indigo-50', //action.iconBackground,
                                            action.color || 'text-primary',
                                            'rounded-lg inline-flex p-3 ring-4 ring-white'
                                        )}
                                    >
                                      <span
                                          dangerouslySetInnerHTML={{
                                              __html: (action.icon)
                                          }}
                                      />
                                    </span>

                                    <div className={'text-sm'}>
                                        {action.title}
                                    </div>
                                </div>
                            </React.Fragment>
                        ))}
                    </div>

                    <div id={'nested'+blokId} className={'bg-white py-8 px-6 rounded-tr-lg rounded-br-lg mt-6'}>
                        {nestedBlocks}
                    </div>

                </div>
            </div>
        </div>
    )
}
